import React from 'react'

const Tutorials = () => {
  return (
    <div>Tutorials</div>
  )
}

export default Tutorials